import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Add({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M12.9428 12.9428L20 12.9428V11.0572H12.9428L12.9428 4L11.0572 4V11.0572L4 11.0572L4 12.9428H11.0572L11.0572 20H12.9428V12.9428Z"
        fill={iconColor}
      />
    </Svg>
  );
}
